export default __webpack_public_path__ + "1a13127ca89c68234de1980fad123d5f.svg";